/**
 * Modal wrapper component of Material UI Dialog
 */
import React from "react"
import PropTypes from "prop-types"
import {
  ModalTitle,
  ModalSubTitle,
  ModalContent,
  IconCont,
  StyledDialog,
} from "./styles"
import Icon from "components/Icon"

export const Modal = ({
  title,
  subtitle,
  content,
  align,
  open,
  icon,
  overflowcontent,
  children,
  ...other // pass through additional css properties for the StyledDialog here
}) => {
  const overflowcontentStyle = overflowcontent
    ? {
        overflow: "visible",
      }
    : {}
  const style = { ...overflowcontentStyle, ...other }
  return (
    <StyledDialog
      open={open}
      PaperProps={{ style }} // NOTE: override css properties via the PaperProps
    >
      <ModalTitle
        align={align}
        variant={"sectionTitle"}
        as={"h1"}
        weight={"light"}
      >
        {icon ? (
          <IconCont>
            <Icon variant={icon} />
          </IconCont>
        ) : null}
        {title}
      </ModalTitle>
      {subtitle ? (
        <ModalSubTitle
          align={align}
          variant={"text"}
          as={"div"}
          weight={"bold"}
        >
          {subtitle}
        </ModalSubTitle>
      ) : null}
      <ModalContent align={align}>{children}</ModalContent>
    </StyledDialog>
  )
}

Modal.defaultProps = {
  open: false,
}

Modal.propTypes = {
  title: PropTypes.string,
  align: PropTypes.string,
  subtitle: PropTypes.string,
  content: PropTypes.node,
  open: PropTypes.bool,
}

export default Modal
